import { Fragment, useEffect } from 'react'
import { useMonitoringImmediate } from '../hooks/useMonitoringImmediate'
import { useMonitoringScheduled } from '../hooks/useMonitoringScheduled'
import { useGetRealtimeAppointments } from '../queries/useGetRealtimeAppointments'
import { useLocation } from 'react-router-dom'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useCallMonitoringStore } from '@/modules/VideoCall/store/call-monitoring-store'

const FIVE_SECONDS_IN_MS = 5000
const TWENTY_SECONDS_IN_MS = 20000

export const RealtimeAttendanceMonitoring = () => {
  const location = useLocation()
  const { user } = useAuthContext()

  const {
    realtimeAttendance: { nextScheduled, immediate },
  } = useRealtimeAttendanceContext()

  const isOnVideoCallPage = location.pathname.includes('chamada')

  const { data: realtimeAppointments } = useGetRealtimeAppointments(
    user?.patientId,
    isOnVideoCallPage ? FIVE_SECONDS_IN_MS : TWENTY_SECONDS_IN_MS,
  )

  useMonitoringImmediate({
    realtimeAppointments,
  })
  useMonitoringScheduled({
    realtimeAppointments,
  })

  useEffect(() => {
    const callStatus = [
      'CHAMADA_INICIADA',
      'CHAMADA_REINICIADA',
      'ATENDIMENTO_INICIADO',
    ]

    if (realtimeAppointments?.length) {
      const realtimeNextScheduled = realtimeAppointments?.find(
        appointment =>
          appointment.idAtendimento?.toString() === nextScheduled?.id,
      )

      const realtimeImmediate = realtimeAppointments?.find(
        appointment => appointment?.idFila?.toString() === immediate?.id,
      )

      if (
        realtimeImmediate?.idFila &&
        callStatus.includes(realtimeImmediate?.status)
      ) {
        useCallMonitoringStore.setState({
          appointmentId: realtimeImmediate?.idAtendimento,
          roomId: realtimeImmediate?.roomId,
          mode: 'immediate',
        })
      }

      if (
        realtimeNextScheduled?.idAtendimento &&
        callStatus.includes(realtimeNextScheduled?.status)
      ) {
        useCallMonitoringStore.setState({
          appointmentId: realtimeNextScheduled?.idAtendimento,
          roomId: realtimeNextScheduled?.roomId,
          mode: 'scheduled',
        })
      }
    }
  }, [immediate?.id, nextScheduled?.id, realtimeAppointments])

  return <Fragment />
}
